<template>
    <div class="TrnxDetail">
        <div>
            <div class="column items-justify paddingHolder">
                <div class="col-6 col-xs-12 col-sm-2 col-md-2 column items-center ">
                    <a class="text-body1">Thank you for investing through Affin Hwang Asset Management. We have received your {{TrxType}} request on {{currentDateTime}}. Details of your {{TrxType}} as below:</a>
                   <!--  <br />
                    <a class="text-body1">We have received your {{TrxType}} request on {{currentDateTime}}</a>
                    <br />
                    <a class="text-body1">Details of your {{TrxType}} as below:</a> -->
                </div>
            </div>
                <!-- investment -->
                 <div v-if="investArray.length>0">
                    <div class="row q-px-sm">
                      
                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Transaction Type</div>
                        </div>
                        <div class="col-xs-14 col-sm-4 col-md-4">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Fund Name</div>
                        </div>
                        
                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Investment Units</div>
                        </div>

                         <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Payment Mode</div>
                        </div>
                         <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Cut Off Time</div>
                        </div>
                        </div>
                    <div class="row q-px-sm" v-for="ivt in investArray" v-bind:key="ivt.index">


                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-value product-key text-center">Investment</div>
                        </div>

                        <div class="col-xs-14 col-sm-4 col-md-4">
                            <div class="product-value product-key text-center">{{ivt.FundName}}</div>
                        </div>

                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-value product-key text-center">{{ivt.Units | thousandSeparator}}</div>
                        </div>

                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-value product-key text-center">{{ivt.PaymentInstruction}}</div>
                        </div>

                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-value product-key text-center">{{ivt.cutOffTime}}</div>
                        </div>

                    </div>
                </div>
                <!---->
            <!-- redemption -->
                 <div v-if="redeemArray.length>0">
                    <div class="row q-px-sm">
                      
                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Transaction Type</div>
                        </div>
                        <div class="col-xs-14 col-sm-4 col-md-4">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Fund Name</div>
                        </div>
                        
                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Units Redeem</div>
                        </div>

                         <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Payment Mode</div>
                        </div>
                         <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Cut Off Time</div>
                        </div>
                        </div>
                    <div class="row q-px-sm" v-for="rdm in redeemArray" v-bind:key="rdm.index">


                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-value product-key text-center">Redemption</div>
                        </div>

                        <div class="col-xs-14 col-sm-4 col-md-4">
                            <div class="product-value product-key text-center">{{rdm.FundName}}</div>
                        </div>

                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-value product-key text-center">{{rdm.Units | thousandSeparator}}</div>
                        </div>

                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-value product-key text-center">{{rdm.PaymentInstruction}}</div>
                        </div>

                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-value product-key text-center">{{rdm.cutOffTime}}</div>
                        </div>

                    </div>
                </div>
                <!---->

                <!-- switching -->
                 <div v-if="switchArray.length>0">
                    <div class="row q-px-sm">
                       
                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Transaction Type</div>
                        </div>
                        <div class="col-xs-14 col-sm-4 col-md-4">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Fund Name</div>
                        </div>
                        
                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Units Redeem</div>
                        </div>

                         <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Payment Mode</div>
                        </div>
                         <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-key text-center text-caption text-bold bg-grey-3">Cut Off Time</div>
                        </div>
                        </div>
                    <div class="row q-px-sm" v-for="swt in switchArray" v-bind:key="swt.index">

                        
                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-value product-key text-center">Switching</div>
                        </div>

                        <div class="col-xs-14 col-sm-4 col-md-4">
                            <div class="product-value product-key text-center">{{swt.FundName}}</div>
                        </div>

                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-value product-key text-center">{{swt.Units | thousandSeparator}}</div>
                        </div>

                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-value product-key text-center">{{swt.PaymentInstruction}}</div>
                        </div>

                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div class="product-value product-key text-center">{{swt.cutOffTime}}</div>
                        </div>

                    </div>
                </div>
                <!---->
        </div>
    </div>
</template>
<script>

import { QForm, QCard, QCardSection, QLinearProgress, Notify , QToggle, QInput, QSelect, QDialog, Loading} from 'quasar'
import axios from 'axios'

import mixins from './mixin'
export default {
    name : 'TrnxDetail', 
    mixins: [mixins],
    components : {
    },
    data() {
        return {
        }
    },
    props: {
        
        currentDateTime:String,
        TrxType:String,
        redeemArray:Array,
        switchArray:Array,
        investArray:Array,
    }, 
    mounted(){
       
    },
    computed: { },
    methods: {}
}
</script>

<style>
.product-key { border: 1px solid #d9dcde; border-bottom: none; min-height: 80px; padding: 5px; }
.product-value { border: 1px solid #d9dcde; font-weight: bold; }

@media only screen and (max-width: 599px) {
  .product-key {
    min-height: unset;
    text-align: left !important;
    padding: 5px;
  }

  .product-value {
    text-align: left !important;
    margin-bottom: 10px;
    padding: 5px;
  }
}

.paddingHolder{
    color: #59599e;
    padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
  padding-bottom:10px;
}

.header{
    color: #59599e;
}

</style>